import { Controller } from "@hotwired/stimulus"

// For companies: Find Your Solution survey — steps 0–4 (4 questions, then offerings + form).
// Stores answers and syncs to form hidden inputs on the last step.
export default class extends Controller {
  static targets = [
    "container",
    "step",
    "progressFill",
    "backBtn",
    "surveyInput1",
    "surveyInput2",
    "surveyInput3",
    "surveyInput4"
  ]

  connect() {
    this.currentStep = 0
    this.answers = []
    this.showStep(0)
  }

  next(event) {
    const index = parseInt(event.currentTarget.dataset.stepIndex, 10)
    if (Number.isNaN(index)) return
    const value = event.currentTarget.dataset.answerValue
    if (value != null) {
      this.answers[this.currentStep] = value
    }
    this.currentStep = index
    this.showStep(index)
  }

  back() {
    if (this.currentStep <= 0) return
    this.currentStep--
    this.showStep(this.currentStep)
  }

  showStep(index) {
    this.stepTargets.forEach((el, i) => {
      el.classList.toggle("hidden", i !== index)
    })

    if (this.hasProgressFillTarget) {
      const percent = index < 4 ? (index + 1) * 25 : 100
      this.progressFillTarget.style.width = `${percent}%`
    }

    if (this.hasBackBtnTarget) {
      this.backBtnTarget.classList.toggle("hidden", index === 0)
    }

    if (index === 4 && this.hasSurveyInput1Target) {
      this.surveyInput1Target.value = this.answers[0] ?? ""
      if (this.hasSurveyInput2Target) this.surveyInput2Target.value = this.answers[1] ?? ""
      if (this.hasSurveyInput3Target) this.surveyInput3Target.value = this.answers[2] ?? ""
      if (this.hasSurveyInput4Target) this.surveyInput4Target.value = this.answers[3] ?? ""
    }

    const scrollEl = this.hasContainerTarget ? this.containerTarget : this.element
    if (scrollEl && typeof window !== "undefined") {
      const rect = scrollEl.getBoundingClientRect()
      const absoluteTop = rect.top + window.scrollY
      const offset = 96 // account for fixed header + breathing room
      window.scrollTo({
        top: Math.max(absoluteTop - offset, 0),
        behavior: "smooth"
      })
    }
  }
}
